import axios from "axios";
import { config } from "./Config";

const instance = axios.create({
  baseURL: config.url,

});

instance.interceptors.request.use(
    async config => {
      config.headers = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        Accept: "application/json",
      }
      return config;
    },
    error => {
      Promise.reject(error)
    });

export default instance;
